import { Button, Col, Image, Modal, Row } from "react-bootstrap";
import { AiOutlineClose } from "react-icons/ai";
import { reactionsIconsByContent } from "../../LikeButton";
import { useEffect, useState } from "react";
import { eInteraction, Interaction } from "../../../../@types/Interaction";
import usePostContext from "../../../../context/PostContext";
import { isEmpty, slice } from "lodash";
import { projectPrimaryColor } from "../../../../generalConfigs";
import useProfilePicture from "../../../../hooks/useProfilePicture";

interface Props {
  show: boolean;
  onHide: Function;
}

export default function ReactionsDetails({ show, onHide }: Props) {
  const [reactions, setReactions] = useState<Interaction[]>([]);
  const [maxIndex, setMaxIndex] = useState<number>(7);
  const [showMoreButton, setShowMoreButton] = useState<boolean>(false);
  const { getProfilePictureURI } = useProfilePicture();
  const { interactions } = usePostContext();
  const reactionsSliced = slice(reactions, 0, maxIndex);
  const maxPerPage = 7;

  function handleShowMore() {
    setMaxIndex(maxIndex + maxPerPage);
  }

  useEffect(() => {
    if (!isEmpty(interactions)) {
      const newReactions = interactions.filter(
        (interaction) => interaction.type === eInteraction.REACTION
      );

      if (newReactions.length > maxIndex + maxPerPage) {
        setShowMoreButton(true);
      } else {
        setShowMoreButton(false);
      }

      setReactions(newReactions);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [interactions, maxIndex]);

  return (
    <Modal show={show} animation={true} onHide={() => onHide()} scrollable>
      <Modal.Header>
        Pessoas que reagiram a essa postagem...
        <div
          className="float-right"
          style={{ cursor: "pointer" }}
          onClick={() => onHide()}
        >
          <AiOutlineClose size={22} />
        </div>
      </Modal.Header>
      <Modal.Body
        style={{ maxHeight: "calc(100vh - 210px)", overflowY: "auto" }}
      >
        {!isEmpty(reactions) &&
          reactionsSliced.map((interaction, i) => {
            if (!isEmpty(interaction.user)) {
              return (
                <Row className="d-flex" key={i}>
                  <Col xs={1}>
                    <Image
                      src={getProfilePictureURI(
                        interaction.user.profile_picture
                      )}
                      className="mg-r-10 img-xs rounded-circle mg-r-5"
                      style={{
                        objectFit: "cover",
                        minWidth: 37,
                        minHeight: 37,
                      }}
                    />
                  </Col>
                  <Col xs={9}>
                    <p className="tx-medium mg-l-5 mg-t-7">
                      {interaction.user.name}
                    </p>
                  </Col>
                  <Col xs={1} className="float-right mg-t-5">
                    <div>
                      {reactionsIconsByContent[interaction.content].checked}
                    </div>
                  </Col>
                  <hr className="wd-100p" />
                </Row>
              );
            } else {
              return <div key={i}></div>;
            }
          })}
        {showMoreButton && (
          <div className="text-center">
            <Button
              style={{ borderRadius: 15, backgroundColor: projectPrimaryColor }}
              onClick={() => handleShowMore()}
            >
              Mostrar mais
            </Button>
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
}
